import Footer from "@/sections/footer";
import { Outlet } from "react-router";

export default function LandingPageLayout() {
  return (
    <div className="relative flex min-h-dvh flex-col overflow-clip">
      <div className="atmosphere" aria-hidden="true"></div>
      <main className="relative grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
